define('home/mixins/asForumProfileCard',[
    'underscore',

    'home/utils/layoutUtils',
    'home/mixins/withTruncate',
    'home/mixins/withThreadCardDefaultFooter',
], function (
    _,

    layoutUtils,
    withTruncate,
    withThreadCardDefaultFooter
) {
    'use strict';

    var asForumProfileCard = function () {
        withTruncate.apply(this, arguments);
        withThreadCardDefaultFooter.apply(this, arguments);

        this.initialize = _.wrap(this.initialize, function (_initialize) {
            _initialize.apply(this, _.rest(arguments));

            var listenable = this.model.thread || this.model;
            this.listenTo(listenable, 'change:content', this.render);

            this.numTitleLines = 3;
        });

        this.serializeData = _.wrap(this.serializeData, function (_serializeData) {
            var data = _serializeData.apply(this, _.rest(arguments));
            var thread = this.model.thread || this.model;

            return _.defaults(data, {
                image: thread.getImage(),
                canShowThreadImage: !layoutUtils.isNarrowLayout(),
                thread: thread.toJSON(),
                numTitleLines: this.numTitleLines,
            });
        });
    };

    return asForumProfileCard;
});

